<template>
  <v-toolbar
    flat
    class="ma-4"
  >
    <v-text-field
        v-model="searchModel"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        style="max-width: 260px"
    ></v-text-field>
    <v-select
        v-model="scopeModel"
        :items="scopes"
        label="Scope"
        clearable
        hide-details
        class="ml-4"
        style="max-width: 160px"
    ></v-select>
    <v-select
        v-model="datasetModel"
        :items="datasets"
        label="Dataset"
        clearable
        hide-details
        class="ml-4"
        style="max-width: 140px"
    ></v-select>
    <v-select
        v-model="versionModel"
        :items="versions"
        label="NEMSIS"
        clearable
        hide-details
        class="ml-4"
        style="max-width: 130px"
    ></v-select>
    <v-spacer></v-spacer>
    <v-btn
        color="primary"
        dark
        @click="$emit('clickAdd')"
    >
      {{ $t('schematrons.newSchematron') }}
    </v-btn>
  </v-toolbar>
</template>
<script>
import SCHEMATRON_SCOPES from '@/enums/schematronScopes';
import NEMSIS_DATASETS from '@/enums/nemsisDatasets';

export default {
  name: 'Toolbar',
  props: {
    search: {
      type: String,
      default: null,
    },
    scope: {
      type: String,
      default: null,
    },
    datasetType: {
      type: String,
      default: null,
    },
    nemsisVersion: {
      type: String,
      default: null,
    },
    versions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      searchModel: this.search,
      scopeModel: this.scope,
      datasetModel: this.datasetType,
      versionModel: this.nemsisVersion,
      scopes: Object.values(SCHEMATRON_SCOPES).map(value => ({
        value,
        text: value.charAt(0).toUpperCase() + value.slice(1),
      })),
      datasets: Object.values(NEMSIS_DATASETS),
    };
  },

  watch: {
    searchModel() {
      this.$emit('update:search', this.searchModel);
    },
    scopeModel() {
      this.$emit('update:scope', this.scopeModel);
    },
    datasetModel() {
      this.$emit('update:datasetType', this.datasetModel);
    },
    versionModel() {
      this.$emit('update:nemsisVersion', this.versionModel);
    },
    // The default arrives after the first render, once the meta call lands.
    nemsisVersion(value) {
      this.versionModel = value;
    },
  },
};
</script>
